import { Component, OnInit } from '@angular/core';
import {CarouselModule} from "primeng/carousel";
import {OrangeButtonComponent} from "../orange-button/orange-button.component";
import { Router } from '@angular/router';

interface ImagesLoghi {
    imgSrc: string;
    name: string;
}

@Component({
    selector: 'app-images-loghi',
    templateUrl: './images-loghi.component.html',
    styleUrls: ['./images-loghi.component.scss'],
    standalone: true,
    imports: [
        CarouselModule,
        OrangeButtonComponent
    ]
})
export class ImagesLoghiComponent implements OnInit {

    images_loghi: ImagesLoghi[] = [
        { imgSrc: 'assets/images/loghi/daily-mail.svg', name: 'Daily Mail' },
        { imgSrc: 'assets/images/loghi/womenshealth.svg', name: 'Women\'s Health' },
        { imgSrc: 'assets/images/loghi/mail-online.svg', name: 'Mail Online' },
        { imgSrc: 'assets/images/loghi/metro.svg', name: 'Metro' },
        { imgSrc: 'assets/images/loghi/the-guardian.svg', name: 'The Guardian' },
        { imgSrc: 'assets/images/loghi/menshealth.svg', name: 'Men\'s Health' },
        { imgSrc: 'assets/images/loghi/the-times-and-the-sunday-times.svg', name: 'The times and the sunday times' }
    ];

    responsiveOptions: any[] | undefined;

    constructor(private router: Router) {
    }
    ngOnInit(): void {
        this.responsiveOptions = [
            {
                breakpoint: '1280px',
                numVisible: 3,
                numScroll: 1
            },
        ]

    }

    goToOrderFlow() {
        this.router.navigate(["order-flow"]);
    }
}
